/**
 * Environment configuration for security settings
 */
// Frontend Version
export const frontendVersion = "01.00.00";

// Environment Configuration
const isDev = import.meta.env.VITE_NODE_ENV === "development";

// API Configuration based on environment
const API_CONFIG = {
  dev: {
    baseUrl: import.meta.env.VITE_API_BASE_URL_DEV,
    redirectUri: import.meta.env.VITE_REDIRECT_URI_DEV,
  },
  prod: {
    baseUrl: import.meta.env.VITE_API_BASE_URL_PROD,
    redirectUri: import.meta.env.VITE_PR_REDIRECT_URI,
  },
};

// Get current API configuration
const currentConfig = isDev ? API_CONFIG.dev : API_CONFIG.prod;
const API_BASE_URL = currentConfig.baseUrl;

// Helper function to safely parse CORS origins
const parseCorsOrigins = (
  envVar: string | undefined,
  defaultOrigins: string[]
): string[] => {
  if (!envVar) return defaultOrigins;
  try {
    return envVar.split(",").filter((origin) => origin.trim() !== "");
  } catch (error) {
    console.warn(
      "Failed to parse CORS origins from environment variable:",
      error
    );
    return defaultOrigins;
  }
};

// Default CORS origins for development and production
const DEFAULT_DEV_ORIGINS = [
  "http://localhost:3000",
  "https://localhost:3000",
  "http://127.0.0.1:3000",
];
const DEFAULT_PROD_ORIGINS = ["https://avetasystem.support"];

export const environment = {
  // Environment flags
  isProduction: import.meta.env.VITE_NODE_ENV === "production",
  isDevelopment: isDev,

  // API configuration
  api: API_CONFIG,
  apiBaseUrl: API_BASE_URL,
  currentConfig,

  // Security settings
  security: {
    // Cookie settings
    cookie: {
      sameSite: "Strict" as const,
      secure: import.meta.env.VITE_NODE_ENV === "production", // Always secure in production
      httpOnly: false, // Can only be set server-side
    },

    // HTTPS enforcement
    https: {
      enforce: import.meta.env.VITE_NODE_ENV === "production", // Only enforce in production
      redirect: true,
      allowLocalhost: true, // Allow HTTP for localhost development
    },

    // CORS settings
    cors: {
      allowCredentials: true,
      allowedOrigins: isDev
        ? parseCorsOrigins(
            import.meta.env.VITE_CORS_ALLOWED_ORIGINS_DEV,
            DEFAULT_DEV_ORIGINS
          )
        : parseCorsOrigins(
            import.meta.env.VITE_CORS_ALLOWED_ORIGINS_PROD,
            DEFAULT_PROD_ORIGINS
          ),
    },

    // Security headers
    headers: {
      "X-Content-Type-Options": "nosniff",
      "X-Frame-Options": "DENY",
      "X-XSS-Protection": "1; mode=block",
      "Referrer-Policy": "strict-origin-when-cross-origin",
      "Permissions-Policy": "geolocation=(), microphone=(), camera=()",
    },
  },
};

export default environment;
